import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
Vue.use(VueRouter)
var i = 1;
function getId() {
  let kq = i;
  i += 1;
  return kq;
}

/*
      { id: getId(), label: 'About', path: 'About', component: () => import('@/views/AboutView.vue'), auth: 0 },
      { id: getId(), label: 'Product', path: 'Product', component: () => import('@/views/Product.vue'), auth: 0 },
      {
        id: getId(), label: 'Môn Học', path: 'MonHoc', meta:{ auth:5 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/MonHoc/Toan.vue'), meta:{auth:9} },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import('@/views/MonHoc/Ly.vue'), meta:{auth:8}},
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import('@/views/MonHoc/Hoa.vue'), meta:{auth:7}},
          {id:getId(), path: 'List',label:"List",component: () => import('../views/MonHoc/List.vue'), meta:{auth:6}},
          {id:getId(), path: 'Edit/:id',label:"Edit",component: () => import('../views/MonHoc/Edit.vue'),show:0, meta:{auth:5} },//<----Đừng hiện lên
        ]
        //auth:0 -> every body can see; show:0 -> do not show in menus
      },
*/  

const routes = [
  {
    id: getId(), label: 'Front', path: '/', meta: { auth: 0 },
    component: () => import('../Layouts/MyWebLayout.vue'), children: [
      { id: getId(), label: 'Home', path: '', component: () => import('@/views/FrontEnd/Home/Index.vue'), meta: { auth: 0 } },
      { id: getId(), label: 'About', path: 'About', component: () => import('@/views/FrontEnd/Home/About.vue'), meta: { auth: 0 } },
      { id: getId(), label: 'Contact', path: 'Contact', component: () => import('@/views/FrontEnd/Home/Contact.vue'), meta: { auth: 0 } },
      //TinTuc
      {
        id: getId(), label: 'Tin Tức', path: 'TinTuc', meta: { auth: 0 },
        component: () => import('../Layouts/MyWebSubLayout.vue'), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/FrontEnd/TinTuc/Toan.vue'), meta: { auth: 0 } },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import('@/views/FrontEnd/TinTuc/Ly.vue'), meta: { auth: 0 } },
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import('@/views/FrontEnd/TinTuc/Hoa.vue'), meta: { auth: 0 } },
          { id: getId(), path: 'List', label: "List", component: () => import('../views/FrontEnd/TinTuc/List.vue'), meta: { auth: 0 } },
          { id: getId(), path: 'Edit/:id', label: "Edit", component: () => import('../views/FrontEnd/TinTuc/Edit.vue'), show: 0, meta: { auth: 0 } },//<----Đừng hiện lên
        ]
      },
      {
        id: getId(), label: 'W3Template', path: 'W3Template', meta: { auth: 0 },
        component: () => import('../Layouts/MyWebSubLayout.vue'), children: [
          { id: getId(), label: 'Display', path: '', component: () => import('@/views/FrontEnd/W3Template/Display.vue'), meta: { auth: 0 } },
          { id: getId(), label: 'Images', path: 'Images', component: () => import('@/views/FrontEnd/W3Template/Images.vue'), meta: { auth: 0 } },
          { id: getId(), label: 'ImageCard', path: 'ImageCard', component: () => import('@/views/FrontEnd/W3Template/ImageCard.vue'), meta: { auth: 0 } },
          { id: getId(), label: 'Slideshow', path: 'Slideshow', component: () => import('@/views/FrontEnd/W3Template/Slideshow.vue'), meta: { auth: 0 } },
        ]
      },
      /*
      {
        id: getId(), label: 'TinTuc', path: 'TinTuc', meta:{ auth:0 }, 
        component: () => import('../Layouts/MyWebSubLayout.vue'), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/FrontEnd/TinTuc/Toan.vue'), meta:{auth:0} },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import('@/views/FrontEnd/TinTuc/Ly.vue'), meta:{auth:0}},
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import('@/views/FrontEnd/TinTuc/Hoa.vue'), meta:{auth:0}},
          {id:getId(), path: 'List',label:"List",component: () => import('../views/FrontEnd/TinTuc/List.vue'), meta:{auth:0}},
          {id:getId(), path: 'Edit/:id',label:"Edit",component: () => import('../views/FrontEnd/TinTuc/Edit.vue'),show:0, meta:{auth:0} },//<----Đừng hiện lên
        ]
      },
      */

      /*
      {
        id: getId(), label: 'Môn Học', path: 'MonHoc', meta:{ auth:0 }, 
        component: () => import('../Layouts/MyWebSubLayout.vue.vue'), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/FrontEnd/MonHoc/Toan.vue'), meta:{auth:0} },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import('@/views/FrontEnd/MonHoc/Ly.vue'), meta:{auth:0}},
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import('@/views/FrontEnd/MonHoc/Hoa.vue'), meta:{auth:0}},
          {id:getId(), path: 'List',label:"List",component: () => import('../views/FrontEnd/MonHoc/List.vue'), meta:{auth:0}},
          {id:getId(), path: 'Edit/:id',label:"Edit",component: () => import('../views/FrontEnd/MonHoc/Edit.vue'),show:0, meta:{auth:0} },//<----Đừng hiện lên
        ]
      },
      */



    ]
  },
  {
    id: getId(), label: 'Admin', path: '/Admin', meta:{auth:1},
    component: () => import('../Layouts/MainLayout.vue'), children: [
      { id: getId(), label: 'Home', path: '', component: () => import('@/views/HomeView.vue'), meta:{auth:1} },
/*
      Template router admin --> Đừng xóa

      {
        id: getId(), label: 'Môn Học', path: 'MonHoc', meta:{ auth:5 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/MonHoc/Toan.vue'), meta:{auth:9} },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import('@/views/MonHoc/Ly.vue'), meta:{auth:8}},
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import('@/views/MonHoc/Hoa.vue'), meta:{auth:7}},
          {id:getId(), path: 'List',label:"List",component: () => import('../views/MonHoc/List.vue'), meta:{auth:6}},
          {id:getId(), path: 'Edit/:id',label:"Edit",component: () => import('../views/MonHoc/Edit.vue'),show:0, meta:{auth:5} },//<----Đừng hiện lên
        ]
        //auth:0 -> every body can see; show:0 -> do not show in menus
      },
*/
      //
      {
        id: getId(), label: 'TestRoles', path: 'TestRoles', meta:{ auth:0 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'TestRoles', path: '', component: () => import('@/views/TestRoles/TestRoles.vue'), meta:{auth:0} },
        ]
      },
      {
        id: getId(), label: 'AdminFunc', path: 'AdminFunc', meta: { auth: 9 },
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          //{ id: getId(), label: 'TestNguoiDung2', path: 'TestNguoiDung2', component: () => import('@/views/AdminFunc/TestNguoiDung2.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ResetUser', path: 'ResetUser', component: () => import('@/views/AdminFunc/ResetUser.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'PhanQuyen', path: 'PhanQuyen', component: () => import('@/views/AdminFunc/PhanQuyen.vue'), meta: { auth: 9 } },
          // { id: getId(), label: 'VaiTros', path: 'VaiTros', component: () => import('@/views/AdminFunc/VaiTros.vue'), meta: { auth: 9 } },
          // { id: getId(), label: 'VaiTros2', path: 'VaiTros2', component: () => import('@/views/AdminFunc/VaiTros2.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'VaiTros3', path: 'VaiTros3', component: () => import('@/views/AdminFunc/VaiTros3.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'BTableInline', path: 'BTableInline', component: () => import('@/views/AdminFunc/BTableInline.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'BTableInline2', path: 'BTableInline2', component: () => import('@/views/AdminFunc/BTableInline2.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'XmlTinTuc', path: 'XmlTinTuc', component: () => import('@/views/AdminFunc/XmlTinTuc.vue'), meta: { auth: 9 } },
          
        ]
      },
      /*
      {
        id: getId(), label: 'BtableNew', path: 'BtableNew', meta:{ auth:5 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'BTableInlineValidateBasic', path: '', component: () => import('@/views/BtableNew/BTableInlineValidateBasic.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableInlineValidate', path: 'BTableInlineValidate', component: () => import('@/views/BtableNew/BTableInlineValidate.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableInlineValidateMulti', path: 'BTableInlineValidateMulti', component: () => import('@/views/BtableNew/BTableInlineValidateMulti.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableData', path: 'BTableData', component: () => import('@/views/BtableNew/BTableData.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableData2', path: 'BTableData2', component: () => import('@/views/BtableNew/BTableData2.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableDataXml', path: 'BTableDataXml', component: () => import('@/views/BtableNew/BTableDataXml.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableLocal (good)', path: 'BTableLocal', component: () => import('@/views/BtableNew/BTableLocal.vue'), meta:{auth:9} },
        ]
      },
      */
      {
        id: getId(), label: 'BtableNew2', path: 'BtableNew2', meta:{ auth:9 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'BtablePage (good)', path: '', component: () => import('@/views/BtableNew2/BtablePage.vue'), meta:{auth:9} },
          { id: getId(), label: 'BtablePageDate(num,radio)', path: 'BtablePageDate', component: () => import('@/views/BtableNew2/BtablePageDate.vue'), meta:{auth:9} },
          { id: getId(), label: 'BtablePageTien(tiền)', path: 'BtablePageTien', component: () => import('@/views/BtableNew2/BtablePageTien.vue'), meta:{auth:9} },
          { id: getId(), label: 'BtablePageSel', path: 'BtablePageSel', component: () => import('@/views/BtableNew2/BtablePageSel.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableDataXml', path: 'BTableDataXml', component: () => import('@/views/BtableNew2/BTableDataXml.vue'), meta:{auth:9} },
          { id: getId(), label: 'BTableLocal', path: 'BTableLocal', component: () => import('@/views/BtableNew2/BTableLocal.vue'), meta:{auth:9} },
          { id: getId(), label: 'PhongSanhXml', path: 'PhongSanhXml', component: () => import('@/views/BtableNew2/PhongSanhXml.vue'), meta:{auth:9} },
        ]
      },
      {
        id: getId(), label: 'BtableUse', path: 'BtableUse', meta:{ auth:9 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'XmlPhongSanh2', path: '', component: () => import('@/views/BtableUse/XmlPhongSanh2.vue'), meta:{auth:9} },
          { id: getId(), label: 'SqlBan2', path: 'SqlBan2', component: () => import('@/views/BtableUse/SqlBan2.vue'), meta:{auth:9} },
          { id: getId(), label: 'GenController', path: 'GenController', component: () => import('@/views/BtableUse/GenController.vue'), meta:{auth:9} },
          { id: getId(), label: 'XacThuc', path: 'XacThuc', component: () => import('@/views/BtableUse/XacThuc.vue'), meta:{auth:9} },
        ]
      },
      // {
      //   id: getId(), label: 'XacThuc', path: 'XacThuc', meta:{ auth:9 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'ForgotPass365', path: '', component: () => import('@/views/XacThuc/ForgotPass365.vue'), meta:{auth:9} },
      //   ]
      // },

      // {
      //   id: getId(), label: 'XacThuc365', path: 'XacThuc365', meta:{ auth:5 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/XacThuc365/Toan.vue'), meta:{auth:9} },
      //     //{ id: getId(), label: 'ForgotPass365', path: 'ForgotPass365', component: () => import('@/views/XacThuc365/ForgotPass365.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'ForgotPass365', path: 'ForgotPass365', component: () => import('@/views/XacThuc365/ForgotPass365.vue'), meta:{auth:9} },
          
      //   ]
      // },
      // {
      //   id: getId(), label: 'XacThucGoogle', path: 'XacThucGoogle', meta:{ auth:0 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'XacThuc', path: '', component: () => import('@/views/XacThucGoogle/XacThuc.vue'), meta:{auth:0} },
      //     { id: getId(), label: 'ForgotPassword', path: 'ForgotPassword', component: () => import('@/views/XacThucGoogle/ForgotPassword.vue'), meta:{auth:0} },
      //   ]
      // },

      
      // {
      //   id: getId(), label: 'LoginBy', path: 'LoginBy', meta:{ auth:5 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'Môn Toán', path: '', component: () => import('@/views/LoginBy/Toan.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'Ms365Login', path: 'Ms365Login', component: () => import('@/views/LoginBy/Ms365Login.vue'), meta:{auth:9} },
      //   ]
      // },



/*
      {
        id: getId(), label: 'SomeUse', path: 'SomeUse', meta:{ auth:9 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'UseComTree', path: '', component: () => import('@/views/SomeUse/UseComTree.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'UseComTreeRouter', path: 'UseComTreeRouter', component: () => import('@/views/SomeUse/UseComTreeRouter.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ViduBaiViet2', path: 'ViduBaiViet2', component: () => import('@/views/SomeUse/ViduBaiViet2.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'UseComUpload', path: 'UseComUpload', component: () => import('@/views/SomeUse/UseComUpload.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'TreeViewUse', path: 'TreeViewUse', component: () => import('@/views/SomeUse/TreeViewUse.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'DatePickerUse', path: 'DatePickerUse', component: () => import('@/views/SomeUse/DatePickerUse.vue'), meta: { auth: 9 } },
        ]
      },
      {
        id: getId(), label: 'Upload5', path: 'Upload5', meta: { auth: 9 },
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'FileUploadUse', path: '', component: () => import('@/views/Upload5/FileUploadUse.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ImageUl', path: 'ImageUl', component: () => import('@/views/Upload5/ImageUl.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'BtableImage', path: 'BtableImage', component: () => import('@/views/Upload5/BtableImage.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'XmlTinTuc2', path: 'XmlTinTuc2', component: () => import('@/views/Upload5/XmlTinTuc2.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ListPagingUse', path: 'ListPagingUse', component: () => import('@/views/Upload5/ListPagingUse.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ComCke4Use', path: 'ComCke4Use', component: () => import('@/views/Upload5/ComCke4Use.vue'), meta: { auth: 9 } },
          { id: getId(), label: 'ViduBaiViet2', path: 'ViduBaiViet2', component: () => import('@/views/Upload5/ViduBaiViet2.vue'), meta: { auth: 9 } },
        ]
      },
*/

      // {
      //   id: getId(), label: 'UseCke4', path: 'UseCke4', meta:{ auth:5 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'TinTucs', path: '', component: () => import('@/views/UseCke4/TinTucs.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'UseListPaging', path: 'UseListPaging', component: () => import('@/views/UseCke4/UseListPaging.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'XmlTinTuc', path: 'XmlTinTuc', component: () => import('@/views/UseCke4/XmlTinTuc.vue'), meta:{auth:9} },
      //   ]
      // },

      // {
      //   id: getId(), label: 'ValidateCom', path: 'ValidateCom', meta:{ auth:5 }, 
      //   component: () => import('../Layouts/MonHocLayout.vue'), children: [
      //     { id: getId(), label: 'Validate', path: 'Validate', component: () => import('@/views/ValidateCom/Validate.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'ValidateUse', path: 'ValidateUse', component: () => import('@/views/ValidateCom/ValidateUse.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'Validate2', path: 'Validate2', component: () => import('@/views/ValidateCom/Validate2.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'Validate2Use', path: 'Validate2Use', component: () => import('@/views/ValidateCom/Validate2Use.vue'), meta:{auth:9} },
      //     { id: getId(), label: 'ListHocSinh', path: 'ListHocSinh', component: () => import('@/views/ValidateCom/ListHocSinh.vue'), meta:{auth:9} },
      //   ]
      // },
      /*
      {
        id: getId(), label: 'ValidateCom2', path: 'ValidateCom2', meta:{ auth:5 }, 
        component: () => import('../Layouts/MonHocLayout.vue'), children: [
          { id: getId(), label: 'TestMyModal', path: '', component: () => import('@/views/ValidateCom2/TestMyModal.vue'), meta:{auth:9} },
          { id: getId(), label: 'Validate', path: 'Validate', component: () => import('@/views/ValidateCom2/Validate.vue'), meta:{auth:9} },
          { id: getId(), label: 'Validate2', path: 'Validate2', component: () => import('@/views/ValidateCom2/Validate2.vue'), meta:{auth:9} },
          { id: getId(), label: 'TinTuc', path: 'TinTuc', component: () => import('@/views/ValidateCom2/TinTuc.vue'), meta:{auth:9} },
        ]
      },
      */

    ]
  },
  { id: getId(), label: 'Login', path: '/login', component: () => import('../views/Login.vue'), meta: { auth: 0 } },
  // { id: getId(), label: 'ForgotPasswordGoogle', path: '/ForgotPasswordGoogle', component: () => import('../views/ForgotPasswordGoogle.vue'), meta: { auth: 0 } },
  // { id: getId(), label: 'ForgotPass365', path: '/ForgotPass365', component: () => import('../views/ForgotPass365.vue'), meta: { auth: 0 } },
  
  { id: getId(), label: 'ChangePass', path: '/ChangePass', component: () => import('@/views/ChangePass.vue'), meta: { auth: 1 } },
  { id: getId(), label: 'DangKy', path: '/DangKy', component: () => import('@/views/Dangky.vue'), meta: { auth: 9 } },
  { id: getId(), path: "*", redirect: '/' ,meta: { auth: 0 } }
]

store.state.routes = routes;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let level = localStorage.getItem("level") == null ? 0 : localStorage.getItem("level");
let logged = (level == 0) ? 0 : 1;
router.beforeEach((to, from, next) =>
{
  let auth = to.meta.auth;
  //console.log(JSON.stringify({ level: level, auth: auth }));
  if (level >= auth) {
    next();
  } else {
    if (to.path == '/Login') {

    } else {
      next('/Login');
    }
  }

});

export default router